import { barChartItem } from './barChart';




export const webFrameworksChartItems: barChartItem[] = [
  {
    itemName: 'Laravel',
    itemPercentage: 90
  },
  {
    itemName: 'Nuxt',
    itemPercentage: 80
  },
  {
    itemName: 'Vue',
    itemPercentage: 80
  },
  {
    itemName: 'React',
    itemPercentage: 70
  },
  {
    itemName: 'Next',
    itemPercentage: 60
  },
  {
    itemName: 'Django',
    itemPercentage: 60
  },
  {
    itemName: 'SpringBoot',
    itemPercentage: 60
  },
];
